import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import router from './router'
import store from './store'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import './utils/ml'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEdit, faTimesCircle, faCode, faCopy, faCheckCircle, faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Swal from 'sweetalert2'
import jQuery from 'jquery'
import '@/assets/sass/style.sass'
import '../node_modules/vue-cookieconsent-component/src/scss/_cookie-consent.scss'
import VueCookies from 'vue-cookies'
import { VLazyImagePlugin } from 'v-lazy-image'
import VueHead from 'vue-head'

library.add(
  faCode,
  faEdit,
  faTimesCircle,
  faCopy,
  faCheckCircle,
  faCircle
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueHead)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueCookies)
Vue.use(VLazyImagePlugin)

window.jQuery = jQuery
window.$ = jQuery

/* window.Intercom('boot', {
  app_id: 'nix6b748'
}) */

Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue()

// eslint-disable-next-line
new Vue({
  el: '#app',
  Swal,
  VueRouter,
  router,
  store,
  axios,
  BootstrapVue,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js